<template>
    <div class="summaryE">
        <div class="E_one">
            <div class="fw_5 fs_02 mb006">荣誉 <span class="ml002">-</span></div>

            <div class="fx mt04 mb07">
                <div class="E_one_left wow animate__lightSpeedInLeft fx fx_flow_j f_j_a fs_0092">
                    <div>国家高新技术企业</div>
                    <div>软件企业证书</div>
                    <div>软件产品证书</div>
                    <div>知识产权管理体系认证证书</div>
                    <div>江西省VR应用示范单位</div>
                    <div>江西省VR产业创业优秀团队</div>
                    <div>2017年度优秀企业证书</div>
                    <div>企业信用等级证书</div>
                    <div>质量管理体系认证证书</div>
                    <div>豫章师范学院学生实习实践基地</div>
                    <div>南昌营商环境监测点</div>
                    <div>南昌大学产学研合作单位</div>
                    <div>智慧党建十大品牌</div>
                    <div>电子政务中国著名品牌</div>
                    <div>中国制造2025计划2017年度省级专项扶持项目</div>
                    <div>南昌市VR/AR企业科协联盟</div>
                    <div>南昌市红谷滩新区人机智能产业发展促进会2020度会员单位</div>
                </div>
                <div class="E_one_right wow animate__lightSpeedInRight">
                    <img src="@/assets/computer/rongyu/m19.png" class="ig">
                </div>
            </div>
        </div>
        <div class="E_two">
            <div class="E_two_text fw_5 fs_02 ">软件著作权 <span class="ml002">-</span></div>
            <div class="E_swiper prel wow animate__backInUp">
                <swiper 
                    :slidesPerView="5" 
                    loop
                    :autoplay="{ delay: 5000, disableOnInteraction: false }"
                    :navigation="true" 
                    :pagination="{ clickable: true  }"
                    :scrollbar="{ draggable: true }" 
                    :space-between="'-5%'" 
                    :modules="modules" 
                    effect="coverflow"
                    :coverflowEffect="{
                        rotate: 0, //slide做3d旋转时Y轴的旋转角度
                        stretch: 1, //每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
                        depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。
                        modifier: 8, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显
                        slideShadows: true //是否开启slide阴影
                    }"
                    :centeredSlides="true"
                    :observer="true"
		            :observeParents="false" 
                    @mouseenter="enter" 
                    @mouseleave="leave" 
                    @swiper="onSwiper" 
                    @slideChange="onSlideChange">
                    <swiper-slide v-for="(item, index) in arrList" :key="index" class="swiperItem ">
                            <!-- <img :src="item.img" alt="" /> -->
                            <img :src="item.img" class="hzhb"/>
                    </swiper-slide>
                </swiper>
                <img src="@/assets/computer/rongyu/z141.png" alt="" @click="rightClick" class="rightpng wow animate__fadeInRight">
                <img src="@/assets/computer/rongyu/z140.png" alt="" @click="leftClick" class="leftpng wow animate__fadeInLeft">
            </div>
        </div>
    </div>
</template>

<script setup>

import { useRouter } from 'vue-router'
import { ref,defineProps, toRaw ,onMounted} from "vue";

const router = useRouter()


onMounted(() => {
 
});
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/effect-coverflow';  //effect为fade时必须引入，否则可能出现只切换一次就不自动切换的情况

import { Autoplay, Navigation, Pagination, Scrollbar, A11y ,EffectCoverflow} from "swiper/modules";

let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y,EffectCoverflow];

//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
 
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
const onSwiper = (swiper) => {
  // console.log(swiper);
 
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
const rightClick=()=>{
    swiperNew.slidePrev()
}
const leftClick=()=>{
    swiperNew.slideNext()

}
const onSlideChange = () => {
  // console.log("slide change");
};
const arrList = ref([
    {
        img:require('@/assets/computer/rongyu/rongyu.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu1.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu2.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu3.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu4.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu5.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu6.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu7.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu8.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu9.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu10.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu11.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu12.jpg'),
    },{
        img:require('@/assets/computer/rongyu/rongyu13.jpg'),
    },
 ])
</script>

<style scoped>
:deep( .swiper .swiper-pagination ) {
  display: none!important;
}
:deep( .swiper .swiper-button-prev ) {
  display: none!important;
}
:deep( .swiper .swiper-button-next){
    display: none!important;
}
.rightpng{
    position: absolute;
    top: 34%;
    right: -13%;
    width: 0.3rem;
    height: 0.3rem;
    z-index: 2;
}
.leftpng{
    position: absolute;
    top: 34%;
    left: -13%;
    width: 0.3rem;
    height: 0.3rem;
    z-index: 2;
}
.E_one{
    width: 85%;
    margin: 0 auto;
}
.E_one_left{
    width: 35%;
}
.E_one_right{
    width: 65%;
}
.E_two{
    width: 100%;
    background: #f2f2f2;
}

.E_two_text{
    width: 85%;
    margin: 0 auto ;
    padding: 0.5rem 0 1rem;
}
.E_swiper{
    width: 70%;
    margin: 0 auto;
    padding-bottom: 1rem;
}
.hzhb{

    width: 100%;
    height: auto;
}
</style>
